import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"

export const TabbedFilterTitleContainer = styled(Typography)`
    span > span:nth-of-type(1) {
        color: ${({theme}) => theme.colours.text.default};
        text-transform: ${({theme}) => theme.colours.typography.body1.textTransform};
        font-family: ${({theme}) => theme.colours.typography.body1.fontFamily};
        font-size: ${({theme}) => theme.colours.typography.body1.fontSize};
        font-weight: ${({theme}) => theme.colours.typography.body1.fontWeight};
        letter-spacing: ${({theme}) => theme.colours.typography.body1.letterSpacing};
        overflow-wrap: anywhere;
        margin-right: 0.188rem;

        &.is-single-line {
            display: block;
        }
    }

    span > span:nth-of-type(2) {
        color: ${({theme}) => theme.colours.text.muted};
        text-transform: ${({theme}) => theme.colours.typography.body2.textTransform};
        font-family: ${({theme}) => theme.colours.typography.body2.fontFamily};
        font-size: ${({theme}) => theme.colours.typography.body2.fontSize};
        font-weight: ${({theme}) => theme.colours.typography.body2.fontWeight};
        letter-spacing: ${({theme}) => theme.colours.typography.body2.letterSpacing};
    }
` as unknown as typeof Typography
